module.exports = __webpack_public_path__ + "static/media/19.c22ed123.jpg";